export default () => {
    const hamburger = document.querySelector("[data-hamburger]");
    const nav =document.querySelector('.header__navigation')
    const body = document.querySelector("body");
    hamburger.addEventListener("click", () => {
        if (hamburger.classList.contains("active")) {
            body.classList.remove("menu-active");
            nav.classList.remove("active");
            hamburger.classList.remove("active");
        } else {
            body.classList.add("menu-active");
            hamburger.classList.add("active");
            nav.classList.add("active");
        }
    });

    window.addEventListener('scroll', () => {
        if (window.scrollY > 100) {
            body.classList.add('scrolled');
        } else {
            body.classList.remove('scrolled');
        }
    });
};
